export const primaryDocuments = [
    { label: 'playtech.mobile.jumio.passport', value: 'PASSPORT' },
    { label: 'playtech.mobile.jumio.idCard', value: 'ID_CARD' },
    { label: 'playtech.mobile.jumio.drivingLicense', value: 'DRIVING_LICENSE' }
];

export const additionalDocuments = [
    { label: 'playtech.mobile.jumio.utilityBill', value: 'UB' },
    { label: 'playtech.mobile.jumio.phoneBill', value: 'PB' },
    { label: 'playtech.mobile.jumio.healthCareCard', value: 'HCC' },
    { label: 'playtech.mobile.jumio.bankStatement', value: 'BS' },
    { label: 'playtech.mobile.jumio.wohnsitz', value: 'Wohnsitz' },
    { label: 'playtech.mobile.jumio.wageState', value: 'WageState' },
    { label: 'playtech.mobile.jumio.betreibung', value: 'Betreibung' },
    { label: 'playtech.mobile.jumio.beneficialOwner', value: 'BOC' },
    { label: 'playtech.mobile.jumio.other', value: 'Other' }
];
